import React, {useRef, forwardRef, useState, useEffect, Fragment} from 'react'
import MaterialTable from 'material-table'

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import ToggleButton from '@material-ui/lab/ToggleButton'

// Material-UI Icon
import GetAppIcon from '@material-ui/icons/GetApp'
import DeleteIcon from '@material-ui/icons/Delete'
// For Material-Table
import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'

// Custom Component
import useLoading from "../Loading/useLoading"
import LockScreenLoading from '../LockScreenLoading/LockScreenLoading'
import {Alert} from '../Alert/Alert'
import ConfirmDialog from '../Dialog/ConfirmDialog'
import FullScreenDialog from '../Dialog/FullScreenDialog'
import ViewCoverForm from './ViewCoverForm'

// Custom Style
import {whiteColor, oceanBlueColor} from '../../styles/jss/cmsMainStyle'
import coverTableStyle from '../../styles/jss/components/drawingRegister/coverTableStyle'

// Fetch Data
import {downloadCover, getCover, deleteCover} from '../../dataSource/drawingRegister'


const useStyles = makeStyles(theme => coverTableStyle(theme))

const CoverTable = props => {
	const {annotSaveChangeAction, setAnnotSaveChangeAction} = props
	const store = require('store')
	const classes = useStyles()

	const tableRef = useRef()

	const [coverRecords, setCoverRecords] = useState([])
	const [selectedCoverRecord, setSelectedCoverRecord] = useState(null)
	const [selectedRow, setSelectedRow] = useState(null)
	const [coverRefash, setCoverRefash] = useState("")
	const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false)
	const [progressTitle, setProgressTitle] = useState("")

	// Data Table State
	const [actionsIcon, setActionsIcon] = useState([])
	const [dataTableToolbarOpen, setDataTableToolbarOpen] = useState(false)

	// Dialog Control State
	const [coverDetailDialogOpen, setCoverDetailDialogOpen] = useState(false)


	// Alert dialog contral state
	const [alertOpen, setAlertOpen] = useState(false)
	const [alertData, setAlertData] = useState({
		type: "",
		title: "",
		content: ""
	})

	// Confirm dialog contral State
	const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
	const [confirmDialogData, setConfirmDialogData] = useState({
		dialogTitle: "",
		dialogContent: "",
		attentionContent: "",
		confirmAction: "",
		cancelAction: ""
	})


	// Set Alert Content
	const buildAlert = (data) => {
		setAlertData({
			type: data.type,
			title: data.title,
			content: data.content
		})
		setAlertOpen(true)
	}

	// Set Confirm Dialog Content
	const buildConfirmDialog = (data) => {
		setConfirmDialogData({
			dialogTitle: data.dialogTitle,
			dialogContent: data.dialogContent,
			attentionContent: data.attentionContent,
			confirmAction: data.confirmAction,
			cancelAction: data.cancelAction
		})
	}


	// Confirm Dialog Contral Function
	const confirmDialogHandleOpen = (data) => {
		buildConfirmDialog(data)
		setConfirmDialogOpen(true)
	}

	const confirmDialogHandleClose = () => {
		setConfirmDialogOpen(false)
	}


	const tableIcons = {
		Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
		Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
		Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
		DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
		Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
		Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
		FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
		LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
		NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
		PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
		ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
		Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
		SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
		ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
		ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
	}

	const columns = [
		{title: "Cover Type", field: "type_name", width: "10%"},
		{title: "Cover No", field: "cover_no", width: "30%"},
		{title: "Cover Subject", field: "cover_subject", width: "50%"},
		{title: "Date of issue", field: "issue_date", width: "10%"},
	]


	// Dialog Control Function
	const coverDetailDialogHandleOpen = (recordData) => {
		setSelectedCoverRecord(recordData)
		setCoverDetailDialogOpen(true)
	}

	const coverDetailDialogHandleClose = () => {
		setCoverDetailDialogOpen(false)
	}


	const removeCoverConfirmAction = (selectedRow) => {
		confirmDialogHandleOpen({
			dialogTitle: "Remove Cover",
			dialogContent: "Are you sure to remove cover.",
			attentionContent: "Under this Cover, all record will be remove together. Include drawing record, revision record and all related items record",
			confirmAction: () => removeCoverAction(selectedRow),
			cancelAction: removeCoverCancelAction
		})
	}

	const removeCoverAction = (selectedRow) => {
		confirmDialogHandleClose()

		selectedRow.map(rowRes => {
			deleteCover(rowRes.cover_seq).then(res => {
				setCoverRefash(res.code)

				buildAlert({
					// Alert Type: success, info, warning, error
					type: "success",
					title: "Success Alert",
					content: "The cover have been removed"
				})
			})
		})
	}

	const removeCoverCancelAction = () => {
		confirmDialogHandleClose()
	}


	const downloadCoverAction = (selectedRow, fullset) => {
		const coverSeq = []

		setProgressTitle("Downloading...")
		setLockScreenLoadingOpen(true)

		selectedRow.map(res => {
			coverSeq.push(res.cover_seq)
		})

		downloadCover(coverSeq, fullset).then(() => {
			console.log("Cover Download Successful")

			tableRef.current.onAllSelected(false)
			setLockScreenLoadingOpen(true)
			setProgressTitle("")
		})
	}


	// Full Screen Dialog Buttom Define
	const coverDetailDialogBtn = [
		// {
		// 	buttonName: "Annotation Publish",
		// 	buttonFunction: annotationPublishActionHandleOpen,
		// 	chooseFile: false
		// },
	]


	useEffect(() => {
		getCover().then(res => {
			setCoverRecords(res.data)
		})
	}, [coverRefash])


	return (
		// console.log("Cover Records List | Variable: coverRecords (CoverTable.js)"),
		// console.log(coverRecords),

		// console.log("Selected Cover Record | Variable: selectedCoverRecord (CoverTable.js)"),
		// console.log(selectedCoverRecord),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<div>
				<LockScreenLoading 
					open={lockScreenLoadingOpen}
					circleSize={200}
					progressTitle={progressTitle}
				/>

				<Alert
					open={alertOpen}
					alertType={alertData.type}
					alertTitle={alertData.title}
					alertContent={alertData.content}
					handleClose={() => setAlertOpen(false)}
				/>

				<ConfirmDialog
					open={confirmDialogOpen}
					dialogTitle={confirmDialogData.dialogTitle}
					dialogContent={confirmDialogData.dialogContent}
					attentionContent={confirmDialogData.attentionContent}
					confirmAction={confirmDialogData.confirmAction}
					cancelAction={confirmDialogData.cancelAction}
				/>

				<FullScreenDialog
					open={coverDetailDialogOpen}
					dialogTitle={"Cover Detail"}

					formContent={
						<ViewCoverForm 
							selectedCoverRecord={selectedCoverRecord}
							setCoverRefash={setCoverRefash}
							annotSaveChangeAction={annotSaveChangeAction}
							setAnnotSaveChangeAction={setAnnotSaveChangeAction}
						/>
					}

					button={coverDetailDialogBtn}
					handleClose={coverDetailDialogHandleClose}
				/>
			</div>

			<MaterialTable
				tableRef={tableRef}
				icons={tableIcons}
				title=""
				columns={columns}
				data={coverRecords}
				actions={actionsIcon}

				// onSearchChange={handleSearchChange}
				// onFilterChange={handleFilterChange}

				onSelectionChange={data => {
					if (data.length > 0) {
						if (data.length === 1) {
							setActionsIcon([
								{
									icon: () => <GetAppIcon color="primary"/>,
									tooltip: "Download Cover",
									onClick: (event, rowData) => {
										downloadCoverAction(rowData, false)
									}
								},
								{
									icon: () => <DeleteIcon color="primary"/>,
									tooltip: 'Delete',
									onClick: (event, rowData) => {
										removeCoverConfirmAction(rowData)
									}
								}
							])
						}
						else {
							setActionsIcon([

								{
									icon: () => <DeleteIcon color="primary"/>,
									tooltip: 'Delete',
									onClick: (event, rowData) => {
										removeCoverConfirmAction(rowData)
									}
								}
							])
						}

						setDataTableToolbarOpen(true)
					}
					else {
						setDataTableToolbarOpen(false)
					}
				}}


				onRowClick={(event, selectedRow) => {
					setSelectedRow(selectedRow.tableData.id)
					coverDetailDialogHandleOpen(selectedRow)
				}}
				

				localization={{
					header : {
						actions: ""
					}
				}}

				options={{
					showTitle: false,
					toolbar: dataTableToolbarOpen,
					grouping: true,
					paging: false,
					selection: true,
					search: false,
					filtering: true,

					minBodyHeight: "100px",
					maxBodyHeight: "670px",

					headerStyle: {
						backgroundColor: oceanBlueColor[10],
						fontFamily: "Gill Sans, sans-serif",
						fontWeight: "bold",
						fontSize: "16px",
						// color: grayColor[8],
						color: whiteColor,
					},

					rowStyle: rowData => ({
						backgroundColor: selectedRow === rowData.tableData.id ? oceanBlueColor[0] : "",
						fontSize: "14px",
						fontFamily: "Gill Sans, sans-serif",
					}),

					// cellStyle: { 
					// 		// backgroundColor: '#039be5',
					// 	fontFamily: "Gill Sans, sans-serif",
					// 		// color: '#FFF',
					// 		// height: 200,
					// 		// maxHeight: 200
					// 	}
				}}
			/>
		</Fragment>
	)
}


export default CoverTable